import React from 'react';
import { loadRazorpayScript, createOrder, openRazorpayCheckout, verifyPayment } from '../utils/razorpay';

const BASE_URL = process.env.REACT_APP_BASEURL;
const ASSOCIATE_MEMBERSHIP_FEE = Number(process.env.REACT_APP_ASSOCIATE_FEE || 1);

const AssociateMemberWelcomePage = () => {
  const handlePay = async () => {
    try {
      await loadRazorpayScript();
      const user = JSON.parse(localStorage.getItem('user'));
      const token = localStorage.getItem('token');
      if (!user || !token) {
        alert('Please login to proceed with payment');
        return;
      }

      const orderResp = await createOrder({
        baseUrl: BASE_URL,
        token,
        amountInRupees: ASSOCIATE_MEMBERSHIP_FEE,
        notes: { module: 'ASSOCIATE_MEMBERSHIP', user_id: user?._id || '' }
      });
      const backendOrder = orderResp?.order || orderResp?.data || orderResp;

      openRazorpayCheckout({
        order: backendOrder,
        name: 'AIOTA - Associate Membership',
        description: 'Associate Membership Fee',
        prefill: { name: user?.name || '', email: user?.email || '', contact: user?.mobile || '' },
        notes: { module: 'ASSOCIATE_MEMBERSHIP' },
        onSuccess: async (rzpResponse) => {
          try {
            const verifyResp = await verifyPayment({
              baseUrl: BASE_URL,
              payload: {
                razorpay_order_id: rzpResponse.razorpay_order_id,
                razorpay_payment_id: rzpResponse.razorpay_payment_id,
                razorpay_signature: rzpResponse.razorpay_signature
              }
            });
            if (verifyResp?.success) {
              alert('Payment successful!');
            } else {
              alert('Payment verification failed.');
            }
          } catch (err) {
            console.error(err);
            alert('Verification failed.');
          }
        },
        onFailure: (err) => {
          alert(err?.message || 'Payment cancelled');
        }
      });
    } catch (err) {
      console.error('Payment init error:', err);
      alert('Unable to start payment.');
    }
  };

  return (
    <div className="welcome-page">
      <h1 className="welcome-heading">Welcome Associate Member</h1>
      <button onClick={handlePay} className="payment-button">Pay Membership</button>
    </div>
  );
};

export default AssociateMemberWelcomePage;